import { Map } from "ol";
import ImageLayer from "ol/layer/Image";
import { MapContextMenuItem } from "../MapContextMenuItem";
import ImageWMSEx from "../net/ImageWMSEx";
import { SelectedFeatureInfo } from "../SelectedFeatureInfo";
import { ILayerFactory } from "./ILayerFactory";
import { LayerUtil } from "../util/LayerUtil"

/**
 * 最大ズームレベル
 */
const LAYER_MAX_ZOOMLEVEL = 18;

/**
 * 最小ズームレベル
 */
const LAYER_MIN_ZOOMLEVEL = 12;

/**
 * API通信用URL
 */
const URL_API = process.env.VUE_APP_XROAD_API_URL;

/**
 * 全国重要物流道路レイヤ名
 */
const LAYER_ROAD_IMP_LOGI_ROAD = "t_road_imp_logi_road";

/**
 * 全国代替補完路レイヤ名
 */
const LAYER_ROAD_ALT_LOGI_ROAD = "t_road_alt_logi_road";

/**
 * 道路属性名称定義
 */
export type RoadAttributeName = "全国重要物流道路" | "全国代替補完路";

/**
 * 道路属性レイヤ表示クラス
 */
export class RoadAttributeLayerFactory implements ILayerFactory {
  /**
   * 表示WMSレイヤ
   */
  private _viewLayer: ImageLayer<ImageWMSEx>;

  /**
   * 表示WMSソース
   */
  private _viewSource: ImageWMSEx;

  /**
   * 表示対象道路属性レイヤ
   */
  private _visibleLayers: string[] = ["全国重要物流道路"];

  /**
   * 地物属性の有無を取得
   */
  isFeatureInfo(): boolean {
    return false;
  }

  /**
   * 範囲地物属性の有無を取得
   */
  isRangeFeatureInfo(): boolean {
    return false;
  }

  /**
   * 右クリック処理の有無を取得
   */
  isRightClickInfo(): boolean {
    return false;
  }

  /**
   * レイヤ定義を取得
   * @param _map openLayers Mapクラス
   */
  getViewLayer(_map?: Map): ImageLayer<ImageWMSEx>[] {
    //WMSレイヤの作成
    this._viewSource = new ImageWMSEx({
      url: URL_API,
      params: {
        LAYERS: null,
        EXCEPTIONS: "application/json",
      },
      ratio: 1,
      serverType: "geoserver",
      crossOrigin: "Anonymous",
    });
    this._viewLayer = new ImageLayer({
      source: this._viewSource,
      maxZoom: LAYER_MAX_ZOOMLEVEL,
      minZoom: LAYER_MIN_ZOOMLEVEL,
      visible: false,
    });
    return [this._viewLayer];
  }

  /**
   * 地物情報を取得
   * @param _map 地図
   * @param _latitude クリック座標緯度
   * @param _longitude クリック座標経度
   * @param _x クリック位置X
   * @param _y クリック位置Y
   * @param _width 地図幅
   * @param _height 地図高さ
   * @param _bBox 地図範囲（BBOX)
   */
  getFeatureInfo(
    _map: Map,
    _latitude: number,
    _longitude: number,
    _x: number,
    _y: number,
    _width: number,
    _height: number,
    _bBox: number[]
  ): Promise<SelectedFeatureInfo[]> {
    return null;
  }

  /**
   * 右クリック処理
   * @param _map 地図
   * @param _latitude クリック座標緯度
   * @param _longitude クリック座標経度
   * @param _x クリック位置X
   * @param _y クリック位置Y
   * @param _width 地図幅
   * @param _height 地図高さ
   * @param _bBox 地図範囲（BBOX)
   */
  getRightClickInfo(
    _map: Map,
    _latitude: number,
    _longitude: number,
    _x: number,
    _y: number,
    _width: number,
    _height: number,
    _bBox: number[]
  ): Promise<MapContextMenuItem[]> {
    return null;
  }

  /**
   * 指定範囲の地物を取得
   * @param _map 地図
   * @param _bBox 地図範囲（BBOX)
   */
  getRangeFeatureInfo(
    _map: Map,
    _bBox: number[]
  ): Promise<SelectedFeatureInfo[]> {
    return null;
  }

  /**
   * レイヤの表示状態を設定
   * @param isVisible 表示有無
   * @param attributeNames 対象道路属性名
   */
  setVisible(isVisible: boolean, attributeNames: RoadAttributeName[]) {
    const layerKeys: string[] = [];
    if (isVisible) {
      this._visibleLayers = attributeNames;
      // 表示対象の道路属性からレイヤ名を抽出
      this._visibleLayers.forEach((attributeName) => {
        if (attributeName === "全国重要物流道路") {
          layerKeys.push(LAYER_ROAD_IMP_LOGI_ROAD);
        } else if (attributeName === "全国代替補完路") {
          layerKeys.push(LAYER_ROAD_ALT_LOGI_ROAD);
        }
      });
      this._viewSource.updateParams({
        LAYERS: layerKeys.join(","),
      });
      this._viewLayer.setVisible(true);
      setTimeout(() => {
        this._viewLayer.setOpacity(1);
      }, 100);
    } else {
      this._viewLayer.setOpacity(Number.MIN_VALUE);
      this._viewLayer.setVisible(false);
    }
  }

  getVisibleLayerCount(): number {
    return this._viewLayer.getVisible() ? this._visibleLayers.length : 0;
  }
  /**
   * 表示レイヤが存在するか判定
   */
   isVisibleLayer(_map:Map) {
    return LayerUtil.isVisibleLayer(_map, this._viewLayer)
  }
}
